import { render, staticRenderFns } from "./overtime-approval.vue?vue&type=template&id=763e2f20&"
import script from "./overtime-approval.vue?vue&type=script&lang=js&"
export * from "./overtime-approval.vue?vue&type=script&lang=js&"
import style0 from "./overtime-approval.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "overtime-approval.vue"
export default component.exports